import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	buttonLabel: {
		id: 'issue-view-common-views.child-issues-panel.ai-issue-breakdown.button-label',
		defaultMessage:
			'Suggest {issueType, select, tasks {subtasks} issues {child issues} other {child issues}}',
		description: 'Button text that triggers generating issues.',
	},
	buttonDefaultTooltipContent: {
		id: 'issue-view-common-views.child-issues-panel.ai-issue-breakdown.button-default-tooltip-content',
		defaultMessage:
			'Ask Atlassian Intelligence to suggest {issueType, select, tasks {subtasks} issues {child issues} other {child issues}} for you.',
		description: 'Tooltip button content that notifies the user what the button is for.',
	},
	buttonModalViewTooltipContent: {
		id: 'issue-view-common-views.child-issues-panel.ai-issue-breakdown.button-modal-view-tooltip-content',
		defaultMessage:
			'Ask Atlassian Intelligence to suggest {issueType, select, tasks {subtasks} issues {child issues} other {child issues}} for you. This will open in a full page view.',
		description:
			'Tooltip button content for modal view that notifies the user that they will be redirected to full page view.',
	},
	placeholderTextNonFinal: {
		id: 'issue-view-common-views.child-issues-panel.ai-issue-breakdown.placeholder-text-non-final',
		defaultMessage: 'Tell us how you want your issues generated, or hit Enter.',
		description:
			'Placeholder text in the Issue Breakdown prompt. This message is not yet finalised and will not be translated until the nonfinal suffix is removed from the message id',
	},
	footerTextDraftList: {
		id: 'issue-view-common-views.child-issues-panel.ai-issue-breakdown.footer-text-draft-list',
		defaultMessage: 'Ask AI to refine suggestions.',
		description: 'Footer text in the Issue Breakdown prompt.',
	},

	footerTextPromptNonFinal: {
		id: 'issue-view-common-views.child-issues-panel.ai-issue-breakdown.footer-text-prompt-non-final',
		defaultMessage: 'Powered by Atlassian Intelligence',
		description:
			'Footer text in the Issue Breakdown prompt. This message is not yet finalised and will not be translated until the nonfinal suffix is removed from the message id',
	},
	footerTextIsWorking: {
		id: 'issue-view-common-views.child-issues-panel.ai-issue-breakdown.footer-text-is-working',
		defaultMessage: 'Atlassian Intelligence is working...',
		description: 'Footer text in the Issue Breakdown when generating child issues.',
	},
	labelCancel: {
		id: 'issue-view-common-views.child-issues-panel.ai-issue-breakdown.label-cancel',
		defaultMessage: 'Cancel',
		description:
			'CancelEsc\'s "Cancel" button label. This message is not yet finalised and will not be translated until the nonfinal suffix is removed from the message id',
	},
	labelStop: {
		id: 'issue-view-common-views.child-issues-panel.ai-issue-breakdown.label-stop',
		defaultMessage: 'Stop',
		description:
			'"Stop" button label. This message is not yet finalised and will not be translated until the nonfinal suffix is removed from the message id',
	},
	labelEscNonFinal: {
		id: 'issue-view-common-views.child-issues-panel.ai-issue-breakdown.label-esc-non-final',
		defaultMessage: 'Esc',
		description:
			'CancelEsc\'s "Esc" button label. This message is not yet finalised and will not be translated until the nonfinal suffix is removed from the message id',
	},
	successFlagTitle: {
		id: 'issue-view-common-views.child-issues-panel.ai-issue-breakdown.success-flag-title',
		defaultMessage: 'Issues successfully created',
		description: 'When issues are created - title.',
	},
	successFlagDescription: {
		id: 'issue-view-common-views.child-issues-panel.ai-issue-breakdown.success-flag-description',
		defaultMessage: 'Your issues have been successfully created',
		description: 'When issues are create - description.',
	},
	errorFlagTitleOnItemNonFinal: {
		id: 'issue-view-common-views.child-issues-panel.ai-issue-breakdown.error-flag-title-on-item-non-final',
		defaultMessage: 'Project or issue ID was not provided.',
		description:
			'Appears when a project or issue id is not provided when clicking a suggested item.',
	},
	errorFlagDescriptionNonFinal: {
		id: 'issue-view-common-views.child-issues-panel.ai-issue-breakdown.error-flag-description-non-final',
		defaultMessage: 'Please try again later.',
		description: 'Generic description for the flag when an error occurs on issue breakdown.',
	},
	statusRetrievingSourceContextNonFinal: {
		id: 'issue-view-common-views.child-issues-panel.ai-issue-breakdown.status-retrieving-source-context-non-final',
		defaultMessage: 'Atlassian Intelligence is reading the parent issue...',
		description: 'Status description when loading on issue breakdown.',
	},
	statusRefiningSuggestedIssuesNonFinal: {
		id: 'issue-view-common-views.child-issues-panel.ai-issue-breakdown.status-refining-suggested-issues-non-final',
		defaultMessage: 'Atlassian Intelligence is refining suggestions...',
		description: 'Status description when loading on issue breakdown.',
	},
	statusSuggestingInitialIssuesNonFinal: {
		id: 'issue-view-common-views.child-issues-panel.ai-issue-breakdown.status-suggesting-initial-issues-non-final',
		defaultMessage: 'Atlassian Intelligence is generating suggestions...',
		description: 'Status description when loading on issue breakdown.',
	},
	statusRemovingDuplicateIssuesNonFinal: {
		id: 'issue-view-common-views.child-issues-panel.ai-issue-breakdown.status-removing-duplicate-issues-non-final',
		defaultMessage: 'Atlassian Intelligence is removing duplicates...',
		description: 'Status description when loading on issue breakdown.',
	},
	statusReformatingIssuesNonFinal: {
		id: 'issue-view-common-views.child-issues-panel.ai-issue-breakdown.status-reformating-issues-non-final',
		defaultMessage: 'Atlassian Intelligence is writing descriptions...',
		description: 'Status description when loading on issue breakdown.',
	},
});
